module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.black-4572744cbb1490713703698c42a8f570.svg";